export default "__VITE_ASSET__tdCEsyIO_gcxcDdQhZrkSQ__";